"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var react_1 = __importDefault(require("react"));
var Label = function (_a) {
    var children = _a.children, text = _a.text, inline = _a.inline, reverse = _a.reverse, dark = _a.dark;
    var displayType = inline ? "inline" : "block";
    var className = dark ? "text-grey-light" : "font-bold text-grey-dark";
    // The `align-middle` is useful when we have some other elements in the label, such as checkboxes
    var span = (react_1.default.createElement("span", { key: "labelSpan", className: "".concat(displayType, " ").concat(className, " font-normal text-grey-dark py-1\nalign-middle select-none") }, text));
    var labelChildren = [span, children];
    if (reverse) {
        labelChildren.reverse();
    }
    return react_1.default.createElement("label", { className: "relative" }, labelChildren);
};
exports.Label = Label;
